module.exports = __webpack_public_path__ + "static/img/5722_phase_function_Paper_PointsHejduk_Prediction.490f0e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5722_phase_function_Paper_PointsHejduk_Prediction.png
// module id = c5+S
// module chunks = 0